import { useGetSettingsGeneral } from '../api/generated/arrayscapeGamingDashboardAPI';

export { type GeneralSettings } from '../api/generated/model';

/**
 * React Query hook for fetching general settings (authenticated).
 * Used in the System Settings page for admin configuration.
 *
 * Configuration:
 * - No caching: Always fetches fresh data (important for settings that might be edited)
 * - Deduplication: Multiple simultaneous calls share the same request
 */
export const useGeneralSettings = () => {
  return useGetSettingsGeneral({
    query: {
      staleTime: 0,              // Data is immediately stale
      retry: 1,                   // Only retry once on failure
    },
  });
};
